import createLucideIcon from '../createLucideIcon';

const SplitSquareHorizontal = createLucideIcon('SplitSquareHorizontal', [
  [
    'path',
    { d: 'M 8,19 H 5 C 4,19 3,18 3,17 V 7 C 3,6 4,5 5,5 h 3', key: 'cclgcb' },
  ],
  [
    'path',
    { d: 'm 16,5 h 3 c 1,0 2,1 2,2 v 10 c 0,1 -1,2 -2,2 h -3', key: '171twm' },
  ],
  ['line', { x1: '12', y1: '4', x2: '12', y2: '20', key: '8v58sd' }],
]);

export default SplitSquareHorizontal;
